import SearchResults from './search-results';

export { default as SearchResults2026 } from './search-results-2026';

export default SearchResults;
